import Vue from "vue";
import Router from "vue-router";
import login from "@/components/login";
import register from "@/components/register";
import helplist from "@/components/helplist";


//userType:1代表用户端和服务端通用,2用户端，3服务商端 4货代服务商端
Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [{
        path: "/login",
        component: login,
        meta: {
            userType: 1,
            isNeedLogin: false,
        },
    },
    {
      path: "/receipt",
      component: resolve =>
        require([
          "@/components/pages/receipt.vue"
        ], resolve),
      meta: {
          userType: 1,
          isNeedLogin: false,
      },
    },
    {
        // 选品中心商品分享页：手机扫码打开，免登录访问
        path: "/mallShare",
        component: resolve =>
          require([
            "@/components/mallShare.vue"
          ], resolve),
        meta: {
            userType: 1,
            isNeedLogin: false,
        },
    },
    {
        path: "/register",
        component: register,
        meta: {
            userType: 1,
            isNeedLogin: false,
        },
    },
       // 帮助
       {
        path: "/helplist",
        component: helplist,
        meta: {
            userType: 1,
            isNeedLogin: false,
      },
    },
    {
        path: "/",
        redirect: "/Home/HomePage",
        component: resolve => require(["@/components/layout/NavBar.vue"], resolve),
        children: [{
            path: "/Home",
            component: resolve => require(["@/components/layout/Home.vue"], resolve),
            children: [
                // 首页
                {
                    path: "HomePage",
                    component: resolve =>
                        require(["@/components/pages/Home"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                // 首页
                // 产品
                {
                    path: "Product",
                    component: resolve =>
                        require(["@/components/pages/Home/product/Product.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                {
                    path: "Logistics",
                    component: resolve =>
                        require(["@/components/pages/Home/product/Logistics.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                // 产品
                // 服务
                {
                    path: "Tools",
                    component: resolve =>
                        require(["@/components/pages/Home/server/Tools.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                {
                    path: "ServerQuestion",
                    component: resolve =>
                        require(["@/components/pages/Home/server/ServerQuestion.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                {
                    path: "ServerCenter",
                    component: resolve =>
                        require(["@/components/pages/Home/server/ServerCenter.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                {
                  path: "ServeMessage",
                  component: resolve =>
                      require(["@/components/pages/Home/server/ServeMessage.vue"], resolve),
                  meta: {
                      userType: 1,
                      isNeedLogin: false,
                  },
              },
                // 服务
                // 关于我们
                {
                    path: "Us",
                    component: resolve =>
                        require(["@/components/pages/Home/aboutUs/Us.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                // 关于我们
                // 流程
                {
                    path: "CooperateOrder",
                    component: resolve =>
                        require(["@/components/pages/Home/order/CooperateOrder.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                {
                    path: "NewHandle",
                    component: resolve =>
                        require(["@/components/pages/Home/order/NewHandle.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                // 流程
                // 资讯
                {
                    path: "Information",
                    component: resolve =>
                        require(["@/components/pages/Home/information/Information.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                {
                    path: "InformationDetail",
                    component: resolve =>
                        require(["@/components/pages/Home/information/InformationDetail.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                // 资讯
                // 工具
                {
                    path: "DataDownload",
                    component: resolve =>
                        require(["@/components/pages/Home/tool/DataDownload.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                // 工具
                // 选品中心
                {
                    path: "MallCenter",
                    component: resolve =>
                        require(["@/components/pages/Home/mall/MallCenter.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                {
                    path: "MallDetail",
                    component: resolve =>
                        require(["@/components/pages/Home/mall/MallDetail.vue"], resolve),
                    meta: {
                        userType: 1,
                        isNeedLogin: false,
                    },
                },
                // 选品中心
            ],
        },


          // User
        {
            path: "/user",
            redirect: "user/userIndex",
            component: resolve =>
                require(["@/components/pages/User/index.vue"], resolve),
            children: [{
                path: "userIndex",
                component: resolve =>
                    require([
                        "@/components/pages/User/UserIndex/userIndex.vue"
                    ], resolve),
                meta: {
                    userType: 1,
                    isNeedLogin: true,
                },
            },
            ////////////////////////////////////////////////////////////////////用户端
            //运单管理 WaybillManage
            {
                path: "totalWaybill",
                component: resolve =>
                    require(["../components/pages/WaybillManage/TotalWaybill.vue"], resolve)
            },
            {
                path: "totalWaybillDeatil",
                component: resolve =>
                    require(["../components/pages/WaybillManage/TotalWaybillDeatil.vue"], resolve),
                    meta: {
                        activeMenu:'/user/totalWaybill'
                    },
            },
            {
                path: "orderList",
                component: resolve =>
                    require(["../components/pages/WaybillManage/OrderList.vue"], resolve)
            },
            {
                path: "tradeList",
                component: resolve =>
                    require(["../components/pages/tradeManage/tradeList.vue"], resolve)
            },
            {
                path: "jointOrderList",
                component: resolve =>
                    require(["../components/pages/jointOrderManage/jointOrderList.vue"], resolve)
            },
            // 产品管理
            {
                path: "productManage",
                component: resolve =>
                    require([
                        "@/components/pages/User/UserIndex/productManage/productManage.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "addProduct",
                component: resolve =>
                    require([
                        "@/components/pages/User/UserIndex/productManage/addProduct.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "addProperty",
                component: resolve =>
                    require([
                        "@/components/pages/User/UserIndex/productManage/addProperty.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "productList",
                component: resolve =>
                    require([
                        "@/components/pages/User/UserIndex/productManage/productList.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "newProductManage",
                component: resolve =>
                    require([
                        "@/components/pages/User/UserIndex/productManage/newProductManage.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "productDetail",
                component: resolve =>
                    require([
                        "@/components/pages/User/UserIndex/productManage/productDetail.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "copyProduct",
                component: resolve =>
                    require([
                        "@/components/pages/User/UserIndex/productManage/copyProduct.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            // 营销中心 - 选品中心商品管理
            {
                path: "mallProduct",
                component: resolve =>
                    require([
                        "@/components/pages/User/UserIndex/mallProduct/mallProductList.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            // 营销中心 - 我的询盘（平台居中撮合）
            {
                path: "mallInquiry",
                component: resolve =>
                    require([
                        "@/components/pages/User/UserIndex/mallInquiry/mallInquiryList.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            // 营销中心 - 我的收藏
            {
                path: "mallFavorite",
                component: resolve =>
                    require([
                        "@/components/pages/User/UserIndex/mallFavorite/mallFavoriteList.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "selectLinkman",
                component: resolve =>
                    require([
                        "@/components/pages/User/UserIndex/productManage/selectLinkman.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },

            // 立即下单,出口订单
            {
                path: "copyright",
                component: resolve =>
                    require([
                        "@/components/pages/User/orderSomething/copyright.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "orderImport",
                component: resolve =>
                    require([
                        "@/components/pages/User/orderSomething/orderImport.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "orderExport",
                component: resolve =>
                    require([
                        "@/components/pages/User/orderSomething/orderExport.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                    keepAlive: true // 需要缓存
                },
            },
              {
                path: "copyOrderExport",
                component: resolve =>
                  require([
                    "@/components/pages/User/orderSomething/copyOrderExport.vue"
                  ], resolve),
                meta: {
                  userType: 2,
                  isNeedLogin: true,
                  keepAlive: true // 需要缓存
                },
              },
            //下单准备，品牌管理
              {
                path: "addBrand",
                component: resolve =>
                  require(["@/components/pages/User/brand/addBrand.vue"], resolve),
                meta: {
                  userType: 1,
                  isNeedLogin: false,
                },
              },
              {
                path: "brandList",
                component: resolve =>
                  require(["@/components/pages/User/brand/brandList.vue"], resolve),
                meta: {
                  userType: 1,
                  isNeedLogin: false,
                },
              },

              //下单准备，开票人管理
              {
                path: 'drawerManage',
                component: resolve =>
                    require([
                        "@/components/pages/User/orderSomethingReady/drawerManage/drawerManage.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: 'addDrawer',
                component: resolve =>
                    require([
                        "@/components/pages/User/orderSomethingReady/drawerManage/addDrawer.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: 'drawerDetail',
                component: resolve =>
                    require([
                        "@/components/pages/User/orderSomethingReady/drawerManage/drawerDetail.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: 'drawerAptitude',
                component: resolve =>
                    require([
                        "@/components/pages/User/orderSomethingReady/drawerManage/drawerAptitude.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "infoList",
                component: resolve =>
                    require([
                        "@/components/pages/User/infoList/infoList.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "exportOrder",
                component: resolve =>
                    require([
                        "@/components/pages/User/OrderManage/exportOrder.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "exportOrderDetail",
                component: resolve =>
                    require([
                        "@/components/pages/User/OrderManage/exportOrderDetail.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
              {
                path: "exportOrderFinance",
                component: resolve =>
                  require([
                    "@/components/pages/User/OrderManage/exportOrderFinance.vue"
                  ], resolve),
                meta: {
                  userType: 2,
                  isNeedLogin: true,
                },
              },
              {
                path: "exportOrderAttachment",
                component: resolve =>
                  require([
                    "@/components/pages/User/OrderManage/exportOrderAttachment.vue"
                  ], resolve),
                meta: {
                  userType: 2,
                  isNeedLogin: true,
                },
              },
            {
                path: "logisticsOrder",
                component: resolve =>
                    require([
                        "@/components/pages/User/orderManage/logisticsOrder.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            //订单管理-进口订单
            {
                path: "importOrder",
                component: resolve =>
                    require([
                        "@/components/pages/User/orderManage/importOrder.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            //订单管理-进口订单-修改订单
            {
                path: "importOrderUpdate",
                component: resolve =>
                    require([
                        "@/components/pages/User/orderSomething/importOrderUpdate.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            //订单管理-进口订单-详情
            {
                path: "importOrderDetail",
                component: resolve =>
                    require([
                        "@/components/pages/User/orderManage/importOrderDetail.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "message",
                component: resolve =>
                    require([
                        "@/components/pages/User/Message/message.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "messageDetail",
                component: resolve =>
                    require([
                        "@/components/pages/User/Message/messageDetail.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "messageCreate",
                component: resolve =>
                    require([
                        "@/components/pages/User/Message/MessageCreate.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "consignee",
                component: resolve =>
                    require([
                        "@/components/pages/User/Setting/consignee.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "sender",
                component: resolve =>
                    require([
                        "@/components/pages/User/Setting/sender.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "contacts",
                component: resolve =>
                    require([
                        "@/components/pages/User/Setting/contacts.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "myFacilitator",
                component: resolve =>
                    require([
                        "@/components/pages/User/Setting/myFacilitator.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "allFacilitator",
                component: resolve =>
                    require([
                        "@/components/pages/User/Setting/allFacilitator.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "myAccount",
                component: resolve =>
                    require([
                        "@/components/pages/User/Setting/myAccount.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "companyInfo",
                component: resolve =>
                    require([
                        "@/components/pages/User/Setting/companyInfo.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "foreignCurrency",
                component: resolve =>
                    require([
                        "@/components/pages/User/Setting/foreignCurrency.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            {
                path: "foreignAccounts",
                component: resolve =>
                    require([
                        "@/components/pages/User/Setting/ForeignAccounts.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                },
            },
            ///////////货代部分
            //货代列表
            {
                path: "freightList",
                component: resolve =>
                    require([
                        "@/components/pages/User/freightManage/FreightList.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true
                }
            },
            //货代详情
            {
                path: "freightDetail",
                component: resolve =>
                    require([
                        "@/components/pages/User/freightManage/FreightDetail.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true
                }
            },
            //创建货代
            {
                path: "freightAdd",
                component: resolve =>
                    require([
                        "@/components/pages/User/freightManage/FreightAdd.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true
                }
            },
            ////////////////////////////////////////////////////////////////////用户端
            //////////////////////////////////////////////////////////////////// 服务商端
            // 客户
            {
                path: "custom",
                component: resolve =>
                    require([
                        "@/components/pages/User/custom/index.vue"
                    ], resolve),
                meta: {
                    userType: 3,
                    isNeedLogin: true,
                },
            },
            // 客户
            // 服务
            {
                path: 'serve',
                component: resolve =>
                    require([
                        "@/components/pages/User/serve/index.vue"
                    ], resolve),
                meta: {
                    userType: 3,
                    isNeedLogin: true,
                },
            },
            // 服务
            // 员工
            {
                path: "staff",
                component: resolve =>
                    require([
                        "@/components/pages/User/staff/index.vue"
                    ], resolve),
                meta: {
                    userType: 3,
                    isNeedLogin: true,
                },
            },
            // 员工
            // 公司设置
            {
                path: "company",
                component: resolve =>
                    require([
                        "@/components/pages/User/company/index.vue"
                    ], resolve),
                meta: {
                    userType: 3,
                    isNeedLogin: true,
                },
            },
            // 公司设置
            // 有问必答
            {
                path: "answer",
                component: resolve =>
                    require([
                        "@/components/pages/User/answer/index.vue"
                    ], resolve),
                meta: {
                    userType: 3,
                    isNeedLogin: true,
                },
            },
            // 有问必答
            // 在线咨询
            {
                path: "consult",
                component: resolve =>
                    require([
                        "@/components/pages/User/consult/index.vue"
                    ], resolve),
                meta: {
                    userType: 3,
                    isNeedLogin: true,
                },
            },
            {
              path: "foreignExchange",
              component: resolve =>
                  require([
                      "@/components/pages/User/foreignExchange/foreignExchange.vue"
                  ], resolve),
              meta: {
                  userType:2,
                  isNeedLogin: true,
            },
          },
          {
            path: "accountApplication",
            component: resolve =>
              require([
                "@/components/pages/foreignExchange/accountApplication/accountApplication.vue"
              ], resolve),
            meta: {
              userType: 2,
              isNeedLogin: true,
            }
          },
          {
            path: "settlement",
            component: resolve =>
              require([
                "@/components/pages/foreignExchange/settlement/settlement.vue"
              ], resolve),
            meta: {
              userType: 2,
              isNeedLogin: true,
            }
          },
                {
                    path: "settlement2",
                    component: resolve =>
                        require([
                            "@/components/pages/foreignExchange/settlement/settlement2.vue"
                        ], resolve),
                    meta: {
                        userType: 2,
                        isNeedLogin: true,
                    }
                },
          {
            path: "settlementExchange",
            component: resolve =>
              require([
                "@/components/pages/foreignExchange/settlementExchange/settlementExchange.vue"
              ], resolve),
            meta: {
              userType: 2,
              isNeedLogin: true,
            }
          },
                {
                    path: "settlementExchange2",
                    component: resolve =>
                        require([
                            "@/components/pages/foreignExchange/settlementExchange/settlementExchange2.vue"
                        ], resolve),
                    meta: {
                        userType: 2,
                        isNeedLogin: true,
                    }
                },
            {
                path: "forexDetails",
                component: resolve =>
                    require([
                        "@/components/pages/foreignExchange/forexDetails/forexDetails.vue"
                    ], resolve),
                meta: {
                    userType: 2,
                    isNeedLogin: true,
                }
            },
            //公司设置
            // 在线咨询
            //////////////////////////////////////////////////////////////////// 服务商端
            //////////////////////////////////////////////////////////////////// 货代服务商端
            //货代订单
            {
                path: "freightOrders",
                component: resolve =>
                    require([
                        "@/components/pages/Freight/freightModule/FreightOrders.vue"
                    ], resolve),
                meta: {
                    userType: 4,
                    isNeedLogin: true,
                },
            },
            //详情/报价
            {
                path: "freightDetailOption",
                component: resolve =>
                    require([
                        "@/components/pages/Freight/freightModule/FreightDetailOption.vue"
                    ], resolve),
                meta: {
                    userType: 4,
                    isNeedLogin: true,
                },
            },
            //账单详情
            {
              path: "freightBill",
              component: resolve =>
                  require([
                      "@/components/pages/Freight/freightModule/freightBill.vue"
                  ], resolve),
              meta: {
                  userType: 4,
                  isNeedLogin: true,
              },
          },
          //freightGenerate生成账单
          {
            path: "freightGenerate",
            component: resolve =>
                require([
                    "@/components/pages/Freight/freightModule/freightGenerate.vue"
                ], resolve),
            meta: {
                userType: 4,
                isNeedLogin: true,
            },
        },
            //货代详情
            // {
            //     path: "freightOrderDetail",
            //     component: resolve =>
            //         require([
            //             "@/components/pages/Freight/freightModule/FreightOrderDetail.vue"
            //         ], resolve),
            //     meta: {
            //         userType: 4,
            //         isNeedLogin: true,
            //     },
            // },
            //货代询价列表
            {
                path: "freightAskList",
                component: resolve =>
                    require([
                        "@/components/pages/Freight/freightModule/FreightAskList.vue"
                    ], resolve),
                meta: {
                    userType: 4,
                    isNeedLogin: true,
                },
            },
            //待报价/已报价
            // {
            //     path: "freightAskDetail",
            //     component: resolve =>
            //         require([
            //             "@/components/pages/Freight/freightModule/FreightAskDetail.vue"
            //         ], resolve),
            //     meta: {
            //         userType: 4,
            //         isNeedLogin: true,
            //     },
            // },
            //公司信息
            {
                path: "freightCompanyInfo",
                component: resolve =>
                    require([
                        "@/components/pages/Freight/companyModule/freightCompanyInfo.vue"
                    ], resolve),
                meta: {
                    userType: 4,
                    isNeedLogin: true,
                },
            },
            //我的账号
            {
                path: "freightMyAccount",
                component: resolve =>
                    require([
                        "@/components/pages/Freight/companyModule/freightMyAccount.vue"
                    ], resolve),
                meta: {
                    userType: 4,
                    isNeedLogin: true,
                },
            },
            //货代消息通知
            {
                path: "msgList",
                component: resolve =>
                    require([
                        "@/components/pages/Freight/freightMsgModule/MsgList.vue"
                    ], resolve),
                meta: {
                    userType: 4,
                    isNeedLogin: true,
                },
            },
            //消息内容
            {
                path: "msgContent",
                component: resolve =>
                    require([
                        "@/components/pages/Freight/freightMsgModule/MsgContent.vue"
                    ], resolve),
                meta: {
                    userType: 4,
                    isNeedLogin: true,
                },
            },
            //////////////////////////////////////////////////////////////////// 货代服务商端（记得修改usertype）
              {
                path: "/print",
                component: print
              },
            ]
        }
        ]
    },
    {
        path: "/404",
        component: resolve => require(["@/components/404.vue"], resolve)
    },
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js